export const purchaseEditOrderRouteWhitelist = [
  'identity-verification',
  'bank-account-verification',
  'income-information',
  'residency-information',
  'trade-documentation',
  'additional-income',
  'transfer-schedule'
];
